import { twClassMerge } from '@healthhub/react-ui';
import type { ButtonProps as AntdButtonProps } from 'antd';
import { Button as AntdButton } from 'antd';
import type { ReactNode } from 'react';

import styles from './styles.module.css';

const BUTTON_VARIANT = {
  link: 'border-none bg-transparent p-0 shadow-none inline-flex after:animate-none hover:underline',
  primary: 'text-white bg-theme-700 lg:max-w-85.75',
  secondary: 'text-theme-700 bg-transparent border border-theme-700 lg:max-w-85.75',
  text: 'border-none bg-transparent text-functional-black p-0 after:animate-none shadow-none gap-0',
};

interface ButtonProps extends Omit<AntdButtonProps, 'type' | 'variant'> {
  customDisabledStyle?: string;
  /**
   * Button variant
   */
  variant?: keyof typeof BUTTON_VARIANT;
}

const Button = ({ icon, className, customDisabledStyle, variant = 'primary', ...props }: ButtonProps) => {
  const { disabled } = props;

  const renderDecorativeIcon = (icon: ReactNode) => {
    if (!icon) return undefined;

    return <span aria-hidden="true">{icon}</span>;
  };

  return (
    <AntdButton
      {...props}
      className={twClassMerge(
        'rounded-lg px-4 py-3.5 font-semibold text-base h-auto line leading-5',
        BUTTON_VARIANT[variant],
        disabled && (customDisabledStyle || 'border-none bg-functional-slate text-white'),
        className,
        // add this due to global span color
        styles.button
      )}
      icon={renderDecorativeIcon(icon)}
    />
  );
};

export default Button;
